import React from "react";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import useBirthdayWishesEnabled from "../../hooks/useBirthdayWishesEnabled";

type BirthdayWishOptInProps = {
  checked: boolean;
  disabled?: boolean;
  dob?: string;
  onChange: (checked: boolean) => void;
  className?: string;
};

export default function BirthdayWishOptIn({
  checked,
  disabled = false,
  dob,
  onChange,
  className = "",
}: BirthdayWishOptInProps) {
  const { enabled, loading } = useBirthdayWishesEnabled();

  if (loading || !enabled) {
    return null;
  }

  const hasDob = Boolean(dob?.trim());
  const isDisabled = disabled || !hasDob;

  return (
    <div
      className={`rounded-xl border border-slate-200 bg-slate-50/80 p-3 dark:border-slate-600 dark:bg-slate-800/40 ${className}`}
    >
      <label
        className={`flex items-start gap-2.5 ${
          isDisabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"
        }`}
      >
        <input
          type="checkbox"
          checked={checked}
          disabled={isDisabled}
          onChange={(event) => onChange(event.target.checked)}
          className="mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 text-primary focus:ring-primary/30 disabled:cursor-not-allowed"
        />
        <span className="min-w-0">
          <span className="flex items-center gap-1.5 text-xs font-semibold text-slate-800 dark:text-slate-100">
            <CakeOutlinedIcon sx={{ fontSize: 16 }} className="text-primary" />
            Send birthday wishes via SMS
          </span>
          <span className="mt-0.5 block text-[11px] leading-relaxed text-slate-500 dark:text-slate-400">
            {hasDob
              ? "Check to include this patient in automated birthday SMS messages."
              : "Enter date of birth first to opt this patient in for birthday wishes."}
          </span>
        </span>
      </label>
    </div>
  );
}
